import { forwardRef, type ForwardRefRenderFunction } from "react";
import classNames from "classnames";
import { is } from "../_util/is";
import type { IconButtonProps } from "./interfaces";
import styles from "./style.module.scss";

const InternalIconButton: ForwardRefRenderFunction<
  HTMLButtonElement,
  IconButtonProps
> = (
  {
    size,
    circle,
    ghost,
    disabled,
    icon,
    className = "",
    style = {},
    ...otherProps
  },
  ref
) => {
  const iconButtonClassName = classNames(className, styles["icon-button"], {
    _xs: is(size, "xs"),
    _sm: is(size, "sm"),
    _md: is(size, "md"),
    _lg: is(size, "lg"),
    _ghost: ghost,
    _circle: circle,
    _disabled: disabled,
  });

  return (
    <button
      {...otherProps}
      ref={ref}
      className={iconButtonClassName}
      style={style}
    >
      {icon}
    </button>
  );
};

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  InternalIconButton
);

export default IconButton;
